/*
 * @Describe:
 * @Author: wangalong
 * @LastEditTime: 2022-10-28 13:50:33
 */
import Vue from 'vue'

import { ImagePreview } from 'vant'
import { isKbApp } from '@/hooks/use-env'
import { callKBApp } from '@/hooks/use-call-kbapp'
import { navigateTo } from '@/utils/tools'
import { jumpForAction } from '@/utils/kb-bridge'
import { getStaticUrl } from '@/filters/static-url'

/**
 * action处理 降级版
 * 自动适配部分web端能自行处理的action
 * @param {object} param
 * @param {string} param.action
 * @param {object} [param.actionParams]
 * @param {object} [param.beforeSuccess] - 能执行前触发
 * @param {object} [param.beforeFail] - 不能执行前触发
 */
export async function runAction({ action, actionParams = {}, beforeSuccess = () => {}, beforeFail = () => {} }) {
    if (isKbApp) {
        return Promise.resolve(beforeSuccess()).then(() => jumpForAction(Vue.prototype, action, actionParams))
    }

    switch (action) {
        /**
         * @description 视频播放
         */
        case 'pageVideoFullScreen':
            return navigateTo({
                url: `${process.env.VUE_APP_KB_SHARE_HOST}/other/video-display?src=${encodeURIComponent(
                    getStaticUrl(actionParams.video.videoKey),
                )}`,
            })

        /**
         * @description 图片播放
         */
        case 'pageImageFullScreen':
            const indexof = actionParams.images.map(({ url }) => url).indexOf(actionParams.url)
            return ImagePreview({
                images: actionParams.images.map(({ url }) => url),
                startPosition: indexof === -1 ? 0 : indexof,
            })

        /**
         * @description web
         */
        case 'pageWeb':
            // 如果特殊标注了requireLogin,存在第三方需要主动url拼接参数
            if (actionParams.requireLogin) {
                return (
                    callKBApp({
                        action,
                        actionParams,
                    }),
                    Promise.reject('请前往开吧app')
                )
            }

            return Promise.resolve(beforeSuccess()).then(() => {
                return navigateTo({ url: actionParams.url })
            })

        /**
         * @description 视频直播
         */
        case 'pageLiveStreaming':
            return Promise.resolve(beforeSuccess()).then(() => {
                return navigateTo({
                    url: `${process.env.VUE_APP_KB_SHARE_HOST}/videolive/index?liveId=${actionParams.liveStreamingId}`,
                })
            })
        /**
         * @description 跳圈子
         */
        case 'pageCircleTopicDetail':
            return Promise.resolve(beforeSuccess()).then(() => {
                return navigateTo({
                    url: `${process.env.VUE_APP_KB_SHARE_HOST}/circle/${actionParams.threadId}`,
                })
            })

        /**
         * @description 强制打开app,并传递参数
         */
        default:
            return Promise.resolve(beforeFail()).then(() => {
                return (
                    callKBApp({
                        action,
                        actionParams,
                    }),
                    Promise.reject('请前往开吧app')
                )
            })
    }
}
